import { Navigate } from "react-router-dom";
import Login from "../pages/auth/login/Login";
import SignUp from "../pages/auth/signUp/SignUp";
import ResetPassword from "../pages/auth/resetPassword/ResetPassword";
import Registration from "../pages/auth/registration/registration";
import UnderReviewNote from "../pages/auth/registration/UnderReview";
import ProfileRejected from "../pages/auth/registration/ProfileRejected";
import EmailVerification from "../pages/auth/emailVerification/EmailVerification";
import LeadContact from "../pages/web/enquire/lead-contact/LeadContact";
import LandingPage from "../pages/auth/landingPage/LandingPage";
import TermsConditions from "../pages/auth/termsConditions/TermsConditions";
import PrivacyPolicy from "../pages/auth/privacyPolicy/PrivacyPolicy";
import ErrorPage from "../components/common/Page404/ErrorPage";
import NewLandingPage from "../pages/auth/newLandingPage/NewLandingPage";
import SearchProfiles from "../components/newLandingSections/SearchProfiles";
import GeneralRequest from "../pages/web/general-request/GeneralRequest";




export const PublicRoutes = [
    {
        path: "/",
        element: <NewLandingPage />
    },
    {
        path: "/professionals",
        element: <LandingPage />
    },
    {
        path: "/search-profiles",
        element: <SearchProfiles />
    },
    {
        path: "/general-request",
        element: <GeneralRequest />
    },
    {
        path: "login",
        element: <Login />
    },
    {
        path: "signup",
        element: <SignUp />
    },
    {
        path: "reset-password",
        element: <ResetPassword />
    },
    {
        path: "email-verification",
        element: <EmailVerification />
    },
    {
        path: "terms-conditions",
        element: <TermsConditions />
    },
    {
        path: "privacy-policy",
        element: <PrivacyPolicy />
    },
    {
        path: "/profile/:username/inquiry/:id",
        element: <LeadContact />,
    },
    
    {
        path: "*",
        element: <ErrorPage />
    }
]